import { FunctionComponent, MouseEvent, ReactElement } from 'react';

import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import IconButton from '@mui/material/IconButton';
import { TablePaginationActionsProps } from '@mui/material/TablePagination/TablePaginationActions';

const TableActions: FunctionComponent<TablePaginationActionsProps> = (
  props
): ReactElement => {
  const handleFirstPageButtonClick = (
    event: MouseEvent<HTMLButtonElement> | null
  ): void => {
    props.onPageChange(event, 0);
  };

  const handleBackButtonClick = (
    event: MouseEvent<HTMLButtonElement> | null
  ): void => {
    props.onPageChange(event, props.page - 1);
  };

  const handleNextButtonClick = (
    event: MouseEvent<HTMLButtonElement> | null
  ): void => {
    props.onPageChange(event, props.page + 1);
  };

  const handleLastPageButtonClick = (
    event: MouseEvent<HTMLButtonElement> | null
  ): void => {
    props.onPageChange(
      event,
      Math.max(0, Math.ceil(props.count / props.rowsPerPage) - 1)
    );
  };

  const isLastPage = (): boolean => {
    return props.page >= Math.ceil(props.count / props.rowsPerPage) - 1;
  };

  return (
    <>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={props.page === 0}
        aria-label="First Page"
        className="btn-first-page"
        title="First Page"
      >
        <KeyboardDoubleArrowLeftIcon />
      </IconButton>

      <IconButton
        onClick={handleBackButtonClick}
        disabled={props.page === 0}
        aria-label="Previous Page"
        className="btn-prev-page"
        title="Previous Page"
      >
        <KeyboardArrowLeft />
      </IconButton>

      <IconButton
        onClick={handleNextButtonClick}
        disabled={isLastPage()}
        aria-label="Next Page"
        className="btn-next-page"
        title="Next Page"
      >
        <KeyboardArrowRight />
      </IconButton>

      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={isLastPage()}
        aria-label="Last Page"
        className="btn-last-page"
        title="Last Page"
      >
        <KeyboardDoubleArrowRightIcon />
      </IconButton>
    </>
  );
};

export default TableActions;
